/* MJ mega-menu pre-order label.

   Timesact relabels the PDP add-to-cart to "Pre-order" from its own app embed, but
   its selector never reaches the mega menu — that menu is the Buddha app embed
   (config/settings_data.json:119), whose markup Timesact does not scan. So a
   pre-order product offers "Add to Cart" there while the same product says
   "Pre-order" on its product page.

   assets/mj-app-cart-bridge.js already makes those adds carry the selling plan; this
   only corrects what the shopper reads.

   We cannot select on Buddha's class names: the menu is drawn client-side, so none
   of its markup exists in the fetched HTML. A card is identified by its own product
   link instead, which is markup-agnostic and survives the app restyling.
   Theme-rendered buttons are excluded explicitly; nothing here should ever touch a
   button the theme owns.

   The string is products.product.preorder (locales/en.default.json:431), already
   exposed as MinimogStrings.preorder by snippets/theme-data.liquid:43 but until now
   unread by any theme JS. No new locale entry is needed. */
(function () {
  "use strict";

  if (window.MJMenuPreorder) return;
  window.MJMenuPreorder = true;

  var ADD_LABEL = /^\s*add to (cart|bag)\s*$/i;
  var PRODUCT_HREF = /\/products\/([^/?#]+)/;
  var MAX_ANCESTORS = 8; // a card is never further than this above its button
  var DONE_ATTR = "data-mj-preorder-label";

  function preorderHandles() {
    return Array.isArray(window.MJPreorderHandles) ? window.MJPreorderHandles : null;
  }

  function preorderLabel() {
    var strings = window.MinimogStrings;
    var label = strings && strings.preorder;
    return label && String(label).trim() ? label : "Pre-order";
  }

  // Buttons inside theme markup are already correct (or deliberately not relabelled).
  function isThemeOwned(el) {
    return !!(
      el.closest('form[action*="/cart/add"]') ||
      el.closest(".m-add-to-cart") ||
      el.closest("product-form") ||
      el.closest("m-cart-drawer") ||
      el.closest(".m-product-card")
    );
  }

  // The nearest ancestor holding exactly one product link is the card. More than one
  // means we have climbed out of the card into the menu, so we give up rather than
  // guess — a wrong label is worse than none.
  function handleFor(button) {
    var node = button;
    for (var depth = 0; node && depth < MAX_ANCESTORS; depth++, node = node.parentElement) {
      if (!node.querySelectorAll) continue;
      var links = node.querySelectorAll('a[href*="/products/"]');
      if (links.length > 1) return null;
      if (links.length === 1) {
        var match = PRODUCT_HREF.exec(links[0].getAttribute("href") || "");
        if (!match) return null;
        try {
          return decodeURIComponent(match[1]).toLowerCase();
        } catch (e) {
          return match[1].toLowerCase();
        }
      }
    }
    return null;
  }

  // Rewrite only the text that reads "Add to Cart", leaving any icon markup alone.
  function relabel(button, label) {
    var leaves = button.querySelectorAll("*");
    for (var i = 0; i < leaves.length; i++) {
      if (leaves[i].children.length === 0 && ADD_LABEL.test(leaves[i].textContent)) {
        leaves[i].textContent = label;
        return true;
      }
    }

    var changed = false;
    for (var j = 0; j < button.childNodes.length; j++) {
      var child = button.childNodes[j];
      if (child.nodeType === 3 && ADD_LABEL.test(child.nodeValue)) {
        child.nodeValue = label;
        changed = true;
      }
    }
    return changed;
  }

  function scanRoot(root, handles, label) {
    var buttons = root.querySelectorAll('button, a, [role="button"]');
    for (var i = 0; i < buttons.length; i++) {
      var button = buttons[i];
      try {
        if (button.hasAttribute(DONE_ATTR)) continue;
        if (!ADD_LABEL.test(button.textContent)) continue;
        if (isThemeOwned(button)) continue;

        var handle = handleFor(button);
        if (!handle || handles.indexOf(handle) === -1) continue;

        if (relabel(button, label)) button.setAttribute(DONE_ATTR, "");
      } catch (e) {}
    }
  }

  // Buddha builds and rebuilds its menu client-side, so a single pass is not enough.
  var scanTimer = null;
  function scan() {
    var handles = preorderHandles();
    if (!handles || !handles.length) return;

    var label = preorderLabel();
    var roots = document.querySelectorAll('m-header, .m-header, [class*="buddha"], [id*="buddha"]');
    for (var i = 0; i < roots.length; i++) {
      try {
        scanRoot(roots[i], handles, label);
      } catch (e) {}
    }
  }

  function scheduleScan() {
    clearTimeout(scanTimer);
    scanTimer = setTimeout(scan, 120);
  }

  function init() {
    try {
      if (!preorderHandles()) return; // no pre-order products — nothing to relabel

      // The app boots and fills the menu on its own schedule, so sweep a few times
      // before falling back to watching.
      scan();
      setTimeout(scan, 500);
      setTimeout(scan, 1500);

      if (typeof MutationObserver === "undefined") return;

      // Watch the header rather than the document: that is where the menu lives, and
      // it keeps unrelated page activity from waking this up.
      var watched = document.querySelectorAll("m-header, .m-header");
      var observer = new MutationObserver(scheduleScan);
      if (watched.length) {
        for (var i = 0; i < watched.length; i++) {
          observer.observe(watched[i], { childList: true, subtree: true });
        }
      } else if (document.body) {
        observer.observe(document.body, { childList: true, subtree: true });
      }
    } catch (e) {}
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
